import React from 'react';
import './UploadProgress.css';

/**
 * Barra de progreso para subida de archivos.
 * @param {number} percent - Porcentaje (0-100)
 * @param {string} [label] - Texto opcional (ej. "Subiendo... 45%")
 */
const UploadProgress = ({ percent = 0, label }) => {
  const value = Math.min(100, Math.max(0, Number(percent) || 0));
  const isComplete = value >= 100;

  return (
    <div className="upload-progress-wrap" role="progressbar" aria-valuenow={value} aria-valuemin={0} aria-valuemax={100} aria-label={label || 'Progreso de subida'}>
      <div className="upload-progress-bar">
        <div className="upload-progress-fill" style={{ width: `${value}%` }} />
      </div>
      <span className="upload-progress-text">
        {label != null ? label : (isComplete ? 'Listo' : `${Math.round(value)}%`)}
      </span>
    </div>
  );
};

export default UploadProgress;
